import { initialErrors } from '../Constants/ScreenMessages.constants';
import { Types } from '../Constants/Types';

import ScreenMessages from '../Interfaces/screenMessages.interface';

const ScreenMessagesReducer = (
  state: ScreenMessages['status'] = {
    byKey: {},
    loading: false,
    error: initialErrors,
    list: [],
    total: 0,
    pages: 0,
    llist: false,
  },
  action: ScreenMessages['action']
): ScreenMessages['status'] => {
  switch (action.type) {
    case Types.FETCH_SCREEN_MESSAGE: {
      const { key, record } = action.payload;
      const byKey = { ...state.byKey };
      if (record) byKey[key] = record;
      else delete byKey[key];
      return { ...state, byKey };
    }

    case Types.CREATE_SCREEN_MESSAGE:
    case Types.UPDATE_SCREEN_MESSAGE:
      return {
        ...state,
        byKey: { ...state.byKey, [action.payload.key]: action.payload },
        list: state.list.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case Types.FETCH_SCREEN_MESSAGES:
      return {
        ...state,
        list: action.payload?.data || [],
        total: action.payload?.total || 0,
        pages: action.payload?.pages || 0,
      };

    case Types.REMOVE_SCREEN_MESSAGE: {
      const byKey = { ...state.byKey };
      Object.keys(byKey).forEach((key) => {
        if (byKey[key]?._id === action.payload) delete byKey[key];
      });
      return {
        ...state,
        byKey,
        list: state.list.filter((item) => item._id !== action.payload),
        total: Math.max(0, state.total - 1),
      };
    }

    case Types.START_SCREEN_MESSAGES:
      return { ...state, llist: true };

    case Types.END_SCREEN_MESSAGES:
      return { ...state, llist: false };

    case Types.START_SCREEN_MESSAGE:
      return { ...state, loading: true };

    case Types.END_SCREEN_MESSAGE:
      return { ...state, loading: false };

    case Types.RESET_SCREEN_MESSAGE:
      return { ...state, error: initialErrors };

    case Types.ERROR_SCREEN_MESSAGE:
      return {
        ...state,
        error: action.payload
          ? { ...state.error, [action.field!]: action.payload }
          : { ...state.error, [action.field!]: null },
      };

    default:
      return state;
  }
};

export default ScreenMessagesReducer;
